export const ERROR_MESSAGES = {
    PIN_NOT_GENERATED: "Pin is not generated, Please try again !",
    BILL_PAYMENT_ERROR: "Something went wrong, Please try again !",
};

export const RAZORPAY_ERROR_MESSAGES = {
    title: "Unable to process payment",
    description: "Please try again or contact support",
    buttonText: "Try other payment methods",
};

export const INFO_MESSAGES = {
    CART_INSTRUCTION_TOOLTIP: "You can now add cooking request for each item",
};

export const HOLD_ON_ORDER_LOADER_MESSAGES = {
    heading: "Hold on",
    description: "We're verifying your payment status",
};
